import { EventBus, EventTypes } from '../../consts/const-event-types';

export default class SalaryLegendComponent {
  constructor(element) {
    this.el = element
  
    this.salaryLegend = this.el; 

    this.tooltipClearTimeout = null;
  
    // Functions
    this.init()
  }



  init()
  { 
    this.createSalaryLegend();
  }

  createSalaryLegend()
  {
    // Create static salary legend
    this.salaryLegend.innerHTML = 
    `<ul>
    <li data-salary="Standard" role="button"  class="selected" tabindex="0"><span>Standardberegnet timefortjeneste</span>
      <div class="element-tooltip large-tooltip" aria-hidden="true">
        <div class="tooltip-content">
        Den standardberegnede timefortjeneste viser medarbejderens ”normale” timeløn, dvs. timefortjenesten for de timer, der er afregnet til normal sats. Lønbegrebet fortæller, hvad en lønmodtager har fået i løn pr. time, lønmodtageren har aftalt at arbejde, uagtet hvor mange dage lønmodtageren er syg eller arbejder ud over det, som er aftalt.
        Læs mere <a aria-hidden="true" href="https://www.dst.dk/da/Statistik/dokumentation/Times/loenstatistik/fortj-stand" target="_blank">her</a>
        </div>
      </div>
    </li>
    <li data-salary="Performed" role="button"  tabindex="0"><span>Fortjeneste pr. præsteret time</span>
      <div class="element-tooltip large-tooltip" aria-hidden="true">
        <div class="tooltip-content">
        Fortjenesten pr. præsteret time viser medarbejderens gennemsnitlige fortjeneste pr. arbejdet time og arbejdsgiverens omkostninger ved en times udført arbejde ekskl. øvrige arbejdsomkostninger. Fravær i forbindelse med fx ferie, sygdom, barsel mv. afspejles i dette lønbegreb som en højere fortjeneste pr. præsteret time. Overtidstillæg indgår også i lønbegrebet. 

        Læs mere <a aria-hidden="true" href="https://www.dst.dk/da/Statistik/dokumentation/Times/loenstatistik/fortj-prae" target="_blank">her</a>
        </div>
      </div>
    </li>
    </ul>
    `;


    // If JS-components are needed runtime, instantiate them manually:
    const nodes = [...this.el.querySelectorAll('[data-salary]')];

    if(nodes)
    {
      nodes.forEach((node, idx) => 
      {
        node.addEventListener("click", (evt) => 
        {
      

          var allowedClick = evt.target.tagName == "SPAN" ? true: false;



          if(allowedClick)
          {
            const listItems = this.salaryLegend.querySelectorAll("li");
            listItems && listItems.forEach(l => l.classList.remove("selected"));
  
  
            node.classList.add("selected");
  
            var salaryGroup = node.getAttribute("data-salary");
  
            // Emit event with Salary group
  
  
            // create your own event-types for component-to-component communication (fx. this event will be picked up by Header.js component):
            const eventData = {
              detail: {
                chartElement: this.el.parentElement.closest("[data-component]"),
                salaryGroup : salaryGroup
              }
            }
            const ev = new CustomEvent(EventTypes.SALARY_LEGEND_UPDATE, eventData);
            EventBus.dispatchEvent(ev);
          }




        })
      });
    } 
  }









}
